import moment from "moment"
import React from "react"
import { Button } from "reactstrap"
import { dateTimeFormat } from "utils/dateFormatUtils"
import { NOTE_TYPES } from "./InspectionNoteModal"

const INITIAL_INDEX = 1

const ViewNoteCard = ({
   note,
   onEdit,
   index,
   type = NOTE_TYPES.PENDING,
   isLoading,
}) => (
   <div className="py-2 px-2 d-flex flex-column note-view">
      <div className="note-view-content">
         <p className="note-view-text">
            <span>{index + INITIAL_INDEX}. </span>
            {note.note}
         </p>
         {type == NOTE_TYPES.PENDING ? (
            <p className="note-view-text-created">
               Created at:{" "}
               {moment(note.createdAt).utc().format(
                  dateTimeFormat.casitaCustomDateFormat
               )}
            </p>
         ) : (
            <p className="note-view-text-created">
               Resolved at:{" "}
               {moment(note.updatedAt).utc().format(
                  dateTimeFormat.casitaCustomDateFormat
               )}
            </p>
         )}
      </div>
      {!!onEdit && (
         <div className="d-flex justify-content-between align-self-end mt-2">
            <Button
               color="primary"
               onClick={() => onEdit(note.id)}
               className="note-edit-btn"
               disabled={isLoading}
            >
               Edit Note
            </Button>
         </div>
      )}
   </div>
)

export default ViewNoteCard
